import {
  useCallback,
} from "react";
import GridElement from "./RTFOWellbore3DGridElement";

export default function RTFOWellbore3DCartesianPlane3D({
  size,
  wellsMetaData,
  divisions,
  cameraInitialPosition,
  units,
  offset
}) {

  const YZPlane = useCallback(() => (
    <GridElement
      size={size}
      position={[
        0,
        (offset?.y || 0 - size / 2),
        0
      ]}
      markPadding={2}
      scale={wellsMetaData?.axisScale}
      markBottomAxis={2}
      markRightAxis={1}
      markLeftAxis={1}
      markBottomRotation={[0, Math.PI / 2, 0]}
      markRightRotation={[0, Math.PI / 2, 0]}
      markLeftRotation={[0, Math.PI / 2, 0]}
      markLeftAxisAutoRotation={true}
      markRightAxisAutoRotation={true}
      markBottomAxisAutoRotation={true}
      labelRightProps={{
        children: `Length (${units === 'field' ? 'ft' : 'm'})`,
        rotation: [Math.PI, Math.PI / 2, Math.PI / 2],
        fontSize: 1.5
      }}
      labelLeftProps={{
        children: `Length (${units === 'field' ? 'ft' : 'm'})`,
        rotation: [Math.PI, Math.PI / 2, Math.PI / 2],
        fontSize: 1.5
      }}
      labelBottomProps={{
        children: `Length (${units === 'field' ? 'ft' : 'm'})`,
        rotation: [0, Math.PI / 2, 0],
        fontSize: 1.5
      }}
      rotation={[Math.PI / 2, 0, Math.PI / 2]}
      divisions={divisions}
      cameraInitialPosition={cameraInitialPosition}
      units={units}
    />
  ), [size, offset?.y, wellsMetaData?.axisScale, units, divisions, cameraInitialPosition]);

  const XYPlane = useCallback(() => (
    <GridElement
      size={size}
      position={[
        0,
        (offset?.y || 0 - size / 2),
        0
      ]}
      rotation={[Math.PI / 2 + Math.PI, 0, 0]}
      scale={wellsMetaData?.axisScale}
      markPadding={2}
      markTopAxis={0}
      markTopRotation={true}
      markRightAxis={1}
      markRightAxisAutoRotation={true}
      markLeftAxis={1}
      markLeftAxisAutoRotation={true}
      labelRightProps={{
        children: `Length (${units === 'field' ? 'ft' : 'm'})`,
        rotation: [0, 0, Math.PI / 2],
        fontSize: 1.5
      }}
      labelLeftProps={{
        children: `Length (${units === 'field' ? 'ft' : 'm'})`,
        rotation: [0, 0, Math.PI / 2],
        fontSize: 1.5
      }}
      divisions={divisions}
      cameraInitialPosition={cameraInitialPosition}
      units={units}
    />
  ), [size, offset?.y, wellsMetaData?.axisScale, units, divisions, cameraInitialPosition]);

  const XZPlane = useCallback(() => (
    <GridElement
      size={size}
      position={[
        0,
        (offset?.y !== undefined && offset?.y !== 0 ? offset?.y - size / 2 : undefined || 0 - size),
        0
      ]}
      rotation={[0, 0, 0]}
      markPadding={2}
      scale={wellsMetaData?.axisScale}
      divisions={divisions}
      markTopAxis={0}
      markRightAxis={2}
      markBottomAxis={0}
      markBottomRotation={[0, Math.PI, 0]}
      markLeftAxis={2}
      markLeftRotation={[0, -Math.PI / 2, 0]}
      markRightRotation={[0, Math.PI / 2, 0]}
      labelTopProps={{
        children: `Length (${units === 'field' ? 'ft' : 'm'})`,
      }}
      labelBottomProps={{
        children: `Length (${units === 'field' ? 'ft' : 'm'})`,
        rotation: [0, Math.PI, 0],
        fontSize: 1.5
      }}
      labelRightProps={{
        children: `Length (${units === 'field' ? 'ft' : 'm'})`,
        rotation: [0, Math.PI / 2, 0],
        fontSize: 1.5
      }}
      labelLeftProps={{
        children: `Length (${units === 'field' ? 'ft' : 'm'})`,
        rotation: [0, -Math.PI / 2, 0],
        fontSize: 1.5
      }}
      cameraInitialPosition={cameraInitialPosition}
      units={units}
    />
  ), [size, offset?.y, wellsMetaData?.axisScale, divisions, units, cameraInitialPosition]);

  if (
    !size || size === undefined ||
    !wellsMetaData || wellsMetaData === undefined ||
    !divisions || divisions === undefined
  ) {
    return null;
  };

  return (
    <group>
      <XZPlane />
      <XYPlane />
      <YZPlane />
    </group>
  );
};
